import React from 'react';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { string, arrayOf, shape, oneOfType, oneOf, number, bool, func } from 'prop-types';
import { FlexContainer } from "../../layout/FlexContainer";
import { Button } from "../../elements/Button";
import { Submenu } from "../../elements/Submenu";
import { size } from "../../../utils/size";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { ShowOn } from "../../layout/ShowOn";
import { testidFactory } from "../../../utils/testid";
import { Logo } from "../../elements/Logo";
import { HorizontalMenu } from "../HorizontalMenu";
import { MobileHeader } from "./MobileHeader";
import { PHONE_PREFIX } from "./constants";
var TEST_ID_PREFIX = 'contactHeader';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var currencyNoResultsText = _ref.currencyNoResultsText,
      currencyOptions = _ref.currencyOptions,
      currencyValue = _ref.currencyValue,
      languageOptions = _ref.languageOptions,
      languageValue = _ref.languageValue,
      logoHref = _ref.logoHref,
      logoSize = _ref.logoSize,
      logoSizes = _ref.logoSizes,
      logoSrc = _ref.logoSrc,
      logoSrcSet = _ref.logoSrcSet,
      logoSubText = _ref.logoSubText,
      logoText = _ref.logoText,
      navigationMenuItems = _ref.navigationMenuItems,
      onChangeCurrency = _ref.onChangeCurrency,
      onChangeLanguage = _ref.onChangeLanguage,
      phoneNumber = _ref.phoneNumber,
      primaryCTA = _ref.primaryCTA;
  return React.createElement("header", {
    className: "contact-header",
    "data-testid": testid()
  }, React.createElement(ShowOn, {
    computer: true,
    widescreen: true
  }, React.createElement("div", {
    className: "header-grid"
  }, React.createElement(Menu, null, size(languageOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    items: languageOptions,
    name: "language",
    onChange: onChangeLanguage,
    value: languageValue
  })), size(currencyOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    isSearchable: true,
    items: currencyOptions,
    name: "currency",
    noResultsText: currencyNoResultsText,
    onChange: onChangeCurrency,
    value: currencyValue
  })), !!phoneNumber && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, React.createElement("a", {
    href: "".concat(PHONE_PREFIX).concat(phoneNumber.replace(/\s/g, ''))
  }, React.createElement(Icon, {
    labelText: phoneNumber,
    name: ICON_NAMES.PHONE
  })))), React.createElement(Logo, {
    logoHref: logoHref,
    logoSize: logoSize,
    logoSizes: logoSizes,
    logoSrc: logoSrc,
    logoSrcSet: logoSrcSet,
    logoSubText: logoSubText,
    logoSubTextAlignment: "center",
    logoText: logoText
  }), primaryCTA && React.createElement(FlexContainer, {
    alignItems: "center",
    justifyContent: "flex-end"
  }, React.createElement(Button, {
    isRounded: true,
    onClick: primaryCTA.onClick
  }, primaryCTA.text))), React.createElement(HorizontalMenu, {
    className: "is-header",
    hasOverflow: true,
    items: navigationMenuItems
  })), React.createElement(ShowOn, {
    mobile: true,
    tablet: true
  }, React.createElement(FlexContainer, {
    alignItems: "center",
    className: "hidden-contact-header",
    justifyContent: "space-between"
  }, React.createElement(Logo, {
    logoHref: logoHref,
    logoSize: logoSize,
    logoSizes: logoSizes,
    logoSrc: logoSrc,
    logoSrcSet: logoSrcSet,
    logoSubText: logoSubText,
    logoText: logoText
  }), React.createElement(MobileHeader, {
    currencyNoResultsText: currencyNoResultsText,
    currencyOptions: currencyOptions,
    currencyValue: currencyValue,
    languageOptions: languageOptions,
    languageValue: languageValue,
    logoHref: logoHref,
    logoSize: logoSize,
    logoSizes: logoSizes,
    logoSrc: logoSrc,
    logoSrcSet: logoSrcSet,
    logoSubText: logoSubText,
    logoText: logoText,
    navigationItems: navigationMenuItems,
    onChangeCurrency: onChangeCurrency,
    phoneNumber: phoneNumber
  }))));
};
Component.displayName = 'ContactHeader';
Component.defaultProps = {
  currencyNoResultsText: undefined,
  currencyOptions: [],
  currencyValue: null,
  languageOptions: [],
  languageValue: null,
  logoHref: '',
  logoSize: 'medium',
  logoSizes: undefined,
  logoSrc: undefined,
  logoSrcSet: undefined,
  logoSubText: '',
  logoText: '',
  onChangeCurrency: undefined,
  onChangeLanguage: undefined,
  phoneNumber: '',
  primaryCTA: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  currencyNoResultsText: string,
  currencyOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  currencyValue: oneOfType([bool, number, string]),
  languageOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  languageValue: oneOfType([bool, number, string]),
  logoHref: string,
  logoSize: oneOf(['medium', 'large', 'huge']),
  logoSizes: string,
  logoSrc: string,
  logoSrcSet: string,
  logoSubText: string,
  logoText: string,
  navigationMenuItems: arrayOf(shape({
    href: string,
    subItems: arrayOf(shape({
      href: string.isRequired,
      target: string,
      text: string.isRequired
    })),
    target: string,
    text: string.isRequired
  })).isRequired,
  onChangeCurrency: func,
  onChangeLanguage: func,
  phoneNumber: string,
  primaryCTA: shape({
    onClick: func.isRequired,
    text: string.isRequired
  })
} : {};